import React from 'react'
import { Redirect } from 'expo-router'

// The menu tab is a drawer trigger, not a real screen — tab presses are intercepted
// (preventDefault / disabled trigger) so this route should never render. If navigation
// state reconstruction ever lands here (e.g. returning from a public form deep link),
// force the main dashboard instead of showing the drawer as a broken full-screen page.
export default function menu() {
  return <Redirect href="/(tabs)/(home)" />
}